<template>
  <div>
    <v-app-bar flat color="white">
      <div class="pa-2">
        <user-dialog-component
          ref="refDialogComponent"
          @updated="updated"
        ></user-dialog-component>
      </div>
      <v-spacer></v-spacer>
    </v-app-bar>
  </div>
</template>

<script>
import { ref } from "@vue/composition-api";
import userDialogComponent from "./component/userDialogComponent.vue";

export default {
  components: {
    userDialogComponent,
  },
  props: ["content_format_list"],
  setup(props, ctx) {
    const refDialogComponent = ref(null);

    // app-barにあるコンポーネント呼び出し
    const action = (params) => {
      switch (params.action) {
        case "edit":
          refDialogComponent.value.editDialog(params.value);
          break;
      }
    };

    const updated = (user_data) => {
      ctx.emit("updated", user_data);
    };

    return {
      refDialogComponent,
      action,
      updated,
    };
  },
};
</script>
